/** @format */
import React, { FunctionComponent, useEffect, useState } from 'react';
import {
    SimCardServiceTypeAllowedParamCollection,
    SimCardServiceTypeItem,
    SimCardServiceTypeParam,
    SimCardServiceTypeParamCollection,
} from '../../../../interfaces/collections/SimCardServiceInterface';
import { TableBody, TableHead, TableRow } from '@material-ui/core';
import Card from '../../../../components/Card/Card';
import CardBody from '../../../../components/Card/CardBody';
import CardHeader from '../../../../components/Heading/CardHeaderExt';
import { ViewList } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../../helpers/FormGeneral';
import GridContainer from '../../../../components/Grid/GridContainer';
import GridItem from '../../../../components/Grid/GridItem';
import Table from '@material-ui/core/Table';
import TableHeaderContentCell from '../../../../components/Table/TableHeaderContentCell';
import TableCell from '@material-ui/core/TableCell';
import Order from '../../../../interfaces/forms/Order';
import Filter from '../../../../interfaces/forms/Filter';
import I18n from '../../../../components/Translate/I18n';
import { roles, UserRoleHelper } from '../../../../helpers/UserRoleHelper';
import CustomTextButtom from '../../../../components/Buttons/CustomTextButton';
import { getFeatureVerbName } from '../../../../modules/features/FeaturesTypes';
import EditButton from '../../../../components/Buttons/EditButton';
import ViewButton from '../../../../components/Buttons/ViewButton';
import { OplSimCardServiceTypeParamItemSdgAdd } from './OplSimCardServiceTypeParamItemSdgAdd';
import DeleteButton from '../../../../components/Buttons/DeleteButton';
import { ServicesMvneType } from '../../../../modules/lib/hooks/useOperatorType';
import { usePlatformResellerHeaders, usePlatformResellerList } from '../../../../modules/lib/hooks/usePlatformResellerHooks';
import { OplSimCardServiceTypeParamItemSdgEdit } from './OplSimCardServiceTypeParamItemSdgEdit';
import { OplSimCardServiceTypeParamItemSdgView } from './OplSimCardServiceTypeParamItemSdgView';
import { OplSimCardServiceTypeParamItemBmeAdd } from './OplSimCardServiceTypeParamItemBmeAdd';
import { OplSimCardServiceTypeParamItemBmeEdit } from './OplSimCardServiceTypeParamItemBmeEdit';
import { OplSimCardServiceTypeParamItemBmeView } from './OplSimCardServiceTypeParamItemBmeView';
import OPL_STYLE from '../../../../assets/themes/OPL/OplStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import OplAppStyle from '../../../../assets/themes/OPL/jss/App/OplAppStyle';
import { OplSimCardServiceTypeParamItemSdgAddServicePDP5 } from './OplSimCardServiceTypeParamItemSdgAddServicePDP5';
import { OplSimCardServiceTypeParamItemSdgEditServicePDP5 } from './OplSimCardServiceTypeParamItemSdgEditServicePDP5';
import { OplSimCardServiceTypeParamItemSdgViewServicePDP5 } from './OplSimCardServiceTypeParamItemSdgViewServicePDP5';
import { ReactComponent as Email } from '../../../../assets/themes/OPL/img/icons/Email.svg';
import { SmsMessageWithSystemLanguageDialog } from './SmsMessage/SmsMessageWithSystemLanguageDialog';
import { $CombinedState } from 'redux';

type OplSimCardServiceTypeParamItemType = {
    classes: any;
    simCardServiceType: SimCardServiceTypeItem;
    simCardServiceTypeAllowedParamsCollection: SimCardServiceTypeAllowedParamCollection;
};

const OplSimCardServiceTypeParamItem: FunctionComponent<OplSimCardServiceTypeParamItemType> = ({
    classes,
    simCardServiceType,
    simCardServiceTypeAllowedParamsCollection,
}): React.ReactElement => {
    const dispatch = useDispatch();
    const [activeRow, setActiveRow] = useState(-1);
    const [openDialogAdd, setOpenDialogAdd] = useState(false);
    const [openDialogEdit, setOpenDialogEdit] = useState(false);
    const [openDialogView, setOpenDialogView] = useState(false);
    const [paramsList, setParamsList] = useState<SimCardServiceTypeParamCollection | null>(null);
    const [simCardServiceTypeParam, setSimCardServiceTypeParam] = useState<SimCardServiceTypeParam | null>(null);
    const [platformResellerId, setPlatformResellerId] = useState<number | null>(null);
    const [messageDef, setMessageDef] = useState(false);
    const [messageType, setMessageType] = useState(-1);

    const platformResellerList = usePlatformResellerList([]);
    const platformResellerHeaders = usePlatformResellerHeaders(platformResellerList);

    useEffect(() => {
        if (paramsList === null) {
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_type_params')),
                'get_sim_card_service_type_params_custom',
                [{ name: 'simCardServiceType.id', value: simCardServiceType.id }],
                [],
                (data: SimCardServiceTypeParamCollection): void => {
                    setParamsList(data);
                },
                { dispatchAfterCallback: false, propagateDataToCallback: true }
            );
        }
    }, [dispatch, simCardServiceType, paramsList]);

    const editParams = (item: SimCardServiceTypeParam): void => {
        setSimCardServiceTypeParam(item);
        setOpenDialogEdit(true);
    };

    const messageSmsParams = (item: SimCardServiceTypeParam): void => {
        if (item.platformResellerId) {
            let messageType = -1;
            switch (simCardServiceType.serviceType) {
                case ServicesMvneType.BME:
                    messageType = 1;
                    break;
                case ServicesMvneType.SDG:
                    messageType = 3;
                    break;
                default:
                    messageType = -1;
                    break;
            }
            setPlatformResellerId(item.platformResellerId);
            setMessageType(messageType);
            setMessageDef(true);
        }
    };

    const messageSmsNAIParams = (item: SimCardServiceTypeParam): void => {
        setPlatformResellerId(item.platformResellerId);
        setMessageType(2);
        setMessageDef(true);
    }

    const viewParams = (item: SimCardServiceTypeParam): void => {
        setSimCardServiceTypeParam(item);
        setOpenDialogView(true);
    };
    const deleteParams = (item: SimCardServiceTypeParam): void => {
        const itemLoader = new ItemLoaders(dispatch);
        const uri = FormGeneralHelper.getByUri(item['@id']);
        itemLoader.deleteCall(
            FormGeneralHelper.getByUri(item['@id']),
            'delete_sim_card_service_type_params_custom',
            (data: any): void => {
                setParamsList(null);
            },
            { dispatchAfterCallback: false }
        );
    };

    const getPlatformResellerName = (platformResellerId: number): string => {
        for (let i = 0; i < platformResellerHeaders.length; i++) {
            if (platformResellerId === platformResellerHeaders[i].value) {
                return platformResellerHeaders[i].name;
            }
        }
        return '';
    };

    const updateOrderList = (orders: Array<Order>): void => {};
    const updateFilterList = (filters: Array<Filter>): void => {};
    const firstLoad = (): void => {};

    const tableStickyHeader = { root: classes.tableStickyHeader };
    const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
    const tableCellRoot = { root: classes.tableCellRootBordered };
    const tableRowRoot = { root: classes.tableRowRoot };

    return (
        <Card>
            <CardHeader icon={<ViewList />} trans={'prov:feature.service_type_parameters'} />
            <CardBody>
                <GridContainer>
                    {UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_POST) && (
                        <GridItem xs={12} style={{ textAlign: 'right', marginBottom: '10px' }}>
                            <CustomTextButtom callback={(): void => setOpenDialogAdd(true)} label="prov:feature.add_new_for_partner" size="sm" />
                        </GridItem>
                    )}
                    <GridItem xs={12} md={12} lg={12}>
                        <Table>
                            <TableHead className={classes.tableRoot}>
                                <TableRow>
                                    <TableCell classes={tableControlStickyHeader} padding="none" align="left" style={{ width: '10%' }}>
                                        <I18n trans="general:common.commands" />
                                    </TableCell>
                                    <TableCell classes={tableStickyHeader} padding="none" align="center" style={{ width: '20%' }}>
                                        <TableHeaderContentCell
                                            title="prov:feature.operation_name"
                                            textAlign="center"
                                            fieldName="verb"
                                            showSort={false}
                                            onlyFilter={false}
                                            defaultDirection="desc"
                                            searchFieldType="string"
                                            filters={[]}
                                            sort={[]}
                                            updateOrderList={updateOrderList}
                                            updateFilterList={updateFilterList}
                                            searchActionCallback={firstLoad}
                                        />
                                    </TableCell>
                                    <TableCell classes={tableStickyHeader} padding="none" align="center">
                                        <TableHeaderContentCell
                                            title="prov:feature.platform_reseller"
                                            textAlign="center"
                                            fieldName="platformResellerId"
                                            showSort={false}
                                            onlyFilter={false}
                                            defaultDirection="desc"
                                            searchFieldType="string"
                                            filters={[]}
                                            sort={[]}
                                            updateOrderList={updateOrderList}
                                            updateFilterList={updateFilterList}
                                            searchActionCallback={firstLoad}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paramsList &&
                                    paramsList['hydra:member'].map((item) => {
                                        let rowActiveColor = 'white';
                                        if (activeRow === item.id) {
                                            rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
                                        }
                                        return (
                                            <TableRow
                                                classes={tableRowRoot}
                                                key={'key' + item.id}
                                                hover
                                                onClick={(): void => {
                                                    setActiveRow(item.id);
                                                }}
                                                style={{ backgroundColor: rowActiveColor }}
                                            >
                                                <TableCell
                                                    classes={tableControlStickyHeader}
                                                    padding="none"
                                                    align="left"
                                                    style={{ backgroundColor: rowActiveColor }}
                                                >
                                                    <React.Fragment>
                                                        {UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_GET) && (
                                                            <ViewButton
                                                                callback={viewParams}
                                                                callbackParam={{ ...item }}
                                                                tooltipTitle="general:common.preview"
                                                            />
                                                        )}
                                                        {UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_PUT) && (
                                                            <EditButton
                                                                callback={editParams}
                                                                callbackParam={{ ...item }}
                                                                tooltipTitle="general:common.edit"
                                                            />
                                                        )}
                                                        {UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_PUT) &&
                                                            ((simCardServiceType.serviceType === ServicesMvneType.BME ) ||
                                                                (simCardServiceType.serviceType === ServicesMvneType.SDG &&
                                                                    simCardServiceType.mainname === 'serviceBOS')) &&
                                                            item.platformResellerId !== null && (
                                                                <EditButton
                                                                    icons={Email}
                                                                    callback={messageSmsParams}
                                                                    callbackParam={{ ...item }}
                                                                    tooltipTitle="prov:feature.sms_message_configure"
                                                                />
                                                            )}

                                                        {UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_PUT) &&
                                                            ((simCardServiceType.serviceType === ServicesMvneType.BME ) ||
                                                                (simCardServiceType.serviceType === ServicesMvneType.SDG &&
                                                                    simCardServiceType.mainname === 'serviceBOS')) &&
                                                            item.platformResellerId !== null && (
                                                                <EditButton
                                                                    icons={Email}
                                                                    callback={messageSmsNAIParams}
                                                                    callbackParam={{ ...item }}
                                                                    tooltipTitle="prov:feature.sms_message_for_nai_configure"
                                                                />
                                                            )}
                                                        {UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_DELETE) && (
                                                            <DeleteButton
                                                                callback={deleteParams}
                                                                callbackParam={{ ...item }}
                                                                tooltipTitle="general:common.delete"
                                                            />
                                                        )}
                                                    </React.Fragment>
                                                </TableCell>
                                                <TableCell classes={tableCellRoot} padding="none" align="center">
                                                    <I18n trans={'prov:feature.' + getFeatureVerbName(item.verb)} />
                                                </TableCell>
                                                <TableCell classes={tableCellRoot} padding="none" align="center">
                                                    {!item.platformResellerId && <I18n trans="prov:feature.for_all_partners" />}
                                                    {getPlatformResellerName(item.platformResellerId ?? -1)}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </GridItem>
                </GridContainer>
                {simCardServiceType.serviceType === ServicesMvneType.SDG && simCardServiceType.mainname === 'servicePDP5' && (
                    <React.Fragment>
                        <OplSimCardServiceTypeParamItemSdgAddServicePDP5
                            simCardServiceType={simCardServiceType}
                            simCardServiceTypeAllowedParamsCollection={simCardServiceTypeAllowedParamsCollection}
                            open={openDialogAdd}
                            closeCallback={(): void => setOpenDialogAdd(false)}
                            reloadList={(): void => setParamsList(null)}
                        />
                        {simCardServiceTypeParam && (
                            <React.Fragment>
                                <OplSimCardServiceTypeParamItemSdgEditServicePDP5
                                    simCardServiceType={simCardServiceType}
                                    simCardServiceTypeParam={simCardServiceTypeParam}
                                    simCardServiceTypeAllowedParamsCollection={simCardServiceTypeAllowedParamsCollection}
                                    open={openDialogEdit}
                                    closeCallback={(): void => {
                                        setOpenDialogEdit(false), setSimCardServiceTypeParam(null);
                                    }}
                                    reloadList={(): void => setParamsList(null)}
                                />
                                <OplSimCardServiceTypeParamItemSdgViewServicePDP5
                                    simCardServiceType={simCardServiceType}
                                    simCardServiceTypeParam={simCardServiceTypeParam}
                                    simCardServiceTypeAllowedParamsCollection={simCardServiceTypeAllowedParamsCollection}
                                    open={openDialogView}
                                    closeCallback={(): void => {
                                        setOpenDialogView(false), setSimCardServiceTypeParam(null);
                                    }}
                                />
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}
                {simCardServiceType.serviceType === ServicesMvneType.SDG && simCardServiceType.mainname !== 'servicePDP5' && (
                    <React.Fragment>
                        <OplSimCardServiceTypeParamItemSdgAdd
                            simCardServiceType={simCardServiceType}
                            simCardServiceTypeAllowedParamsCollection={simCardServiceTypeAllowedParamsCollection}
                            open={openDialogAdd}
                            closeCallback={(): void => setOpenDialogAdd(false)}
                            reloadList={(): void => setParamsList(null)}
                        />
                        {simCardServiceTypeParam && (
                            <React.Fragment>
                                <OplSimCardServiceTypeParamItemSdgEdit
                                    simCardServiceType={simCardServiceType}
                                    simCardServiceTypeParam={simCardServiceTypeParam}
                                    simCardServiceTypeAllowedParamsCollection={simCardServiceTypeAllowedParamsCollection}
                                    open={openDialogEdit}
                                    closeCallback={(): void => {
                                        setOpenDialogEdit(false), setSimCardServiceTypeParam(null);
                                    }}
                                    reloadList={(): void => setParamsList(null)}
                                />
                                <OplSimCardServiceTypeParamItemSdgView
                                    simCardServiceType={simCardServiceType}
                                    simCardServiceTypeParam={simCardServiceTypeParam}
                                    simCardServiceTypeAllowedParamsCollection={simCardServiceTypeAllowedParamsCollection}
                                    open={openDialogView}
                                    closeCallback={(): void => {
                                        setOpenDialogView(false), setSimCardServiceTypeParam(null);
                                    }}
                                />
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}
                {simCardServiceType.serviceType === ServicesMvneType.BME && (
                    <React.Fragment>
                        <OplSimCardServiceTypeParamItemBmeAdd
                            simCardServiceType={simCardServiceType}
                            simCardServiceTypeAllowedParamsCollection={simCardServiceTypeAllowedParamsCollection}
                            open={openDialogAdd}
                            closeCallback={(): void => setOpenDialogAdd(false)}
                            reloadList={(): void => setParamsList(null)}
                        />
                        {simCardServiceTypeParam && (
                            <React.Fragment>
                                <OplSimCardServiceTypeParamItemBmeEdit
                                    simCardServiceType={simCardServiceType}
                                    simCardServiceTypeParam={simCardServiceTypeParam}
                                    simCardServiceTypeAllowedParamsCollection={simCardServiceTypeAllowedParamsCollection}
                                    open={openDialogEdit}
                                    closeCallback={(): void => {
                                        setOpenDialogEdit(false), setSimCardServiceTypeParam(null);
                                    }}
                                    reloadList={(): void => setParamsList(null)}
                                />
                                <OplSimCardServiceTypeParamItemBmeView
                                    simCardServiceType={simCardServiceType}
                                    simCardServiceTypeParam={simCardServiceTypeParam}
                                    simCardServiceTypeAllowedParamsCollection={simCardServiceTypeAllowedParamsCollection}
                                    open={openDialogView}
                                    closeCallback={(): void => {
                                        setOpenDialogView(false);
                                        setSimCardServiceTypeParam(null);
                                    }}
                                />
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}
                {platformResellerId && (
                    <SmsMessageWithSystemLanguageDialog
                        open={messageDef}
                        close={(): void => {
                            setMessageDef(false);
                            setMessageType(-1);
                            setPlatformResellerId(null);
                        }}
                        simCardServiceType={simCardServiceType}
                        platformResellerId={platformResellerId}
                        type={messageType}
                    />
                )}
            </CardBody>
        </Card>
    );
};

export default withStyles(OplAppStyle)(OplSimCardServiceTypeParamItem);
